var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-info"},[_c('h2',{staticClass:"heading-2"},[_vm._v(_vm._s(_vm.title))]),_c('h1',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }